module.exports = __webpack_public_path__ + "static/media/under-the-tree-640.271cc58f.jpg";